import { query, collection, getDocs, where, limit, orderBy , doc, updateDoc, getDoc, setDoc, addDoc, deleteDoc } from "firebase/firestore";
import useFirebaseConfig from "./useFirebaseConfig";


const useFirestore = () => {
    const { dbFirestore } = useFirebaseConfig();

    const readFirestore = async (table) => {
        const firestore_query = query(collection(dbFirestore, table));
        return await getDocs(firestore_query).then(querySnapshot => {
            return querySnapshot;
        }).catch(err => {
            return err;
        })
    }

    const readFirestoreOneDoc = async(table, id) => {
        const docRef = doc(dbFirestore, table, id);
        return await getDoc(docRef);
    }

    const readFirestoreWithSort = async (table, sort) => {
        const firestore_query = query(collection(dbFirestore, table), orderBy(sort.name, sort.direction));
        return await getDocs(firestore_query).then(querySnapshot => {
            return querySnapshot;
        }).catch(err => {
            return err;
        })
    }

    const readFirestoreWithQuery = async (table, sql) => {
        const firestore_query = query(collection(dbFirestore, table), where(sql.field, sql.operator, sql.data));
        return await getDocs(firestore_query).then(querySnapshot => {
            return querySnapshot;
        }).catch(err => {
            return err;
        })
    }
    
    const readFirestoreWithSortWithLimit = async (table, sort, max_items) => {
        const firestore_query = query(collection(dbFirestore, table), orderBy(sort.name, sort.direction), limit(max_items));
        return await getDocs(firestore_query).then(querySnapshot => {
            return querySnapshot;
        }).catch(err => {
            return err;
        })
    }

    const writeFirestore = async (table, id, data) =>{
        return await setDoc(doc(dbFirestore, table, id), data).then(res => {
            return true;
        }).catch(err => {
            return false;
        })
    }

    const deleteFirstore = async (table, id) => {
        return await deleteDoc(doc(dbFirestore, table, id)).then(res => {
            return true;
        }).catch(err => {
            return false;
        })
    }

    const addFirestore = async (table, data) => {
        try {
          const docRef = await addDoc(collection(dbFirestore, table), data);
          return docRef.id;
        } catch (error) {
          throw error;
        }
      };
    
    

    const updateFirestore = async(table, document_id, data) => {
        const updateRef = doc(dbFirestore, table, document_id)
        return await updateDoc(updateRef, data).then(res => {
            return true;
        }).catch(err => {
            return false;
        })
    }

    return {readFirestoreOneDoc, readFirestore, readFirestoreWithSort, readFirestoreWithQuery, readFirestoreWithSortWithLimit,
    writeFirestore, addFirestore, updateFirestore, deleteFirstore};
}

export default useFirestore;